// Copyright © 2021 Move Closer
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export class AbstractTypeDriver {
    /**
     * @inheritDoc
     */
    canDescribe(id, record) {
        if (!this.hasTypeEntries(record)) {
            return false;
        }
        return this.hasRelated(id, record);
    }
    /**
     * @inheritDoc
     */
    dependentTypes() {
        return [];
    }
    /**
     * @inheritDoc
     */
    describe(id, record) {
        this.throwWhenMissing(id, record);
        return { ...record[this.typeKey][`${id}`] };
    }
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    resolve(id, record, config, driverResolver) {
        this.throwWhenMissing(id, record);
        return { ...record[this.typeKey][`${id}`] };
    }
    /**
     * @inheritDoc
     */
    reset() {
        // NOTICE! Should be implemented in drivers
    }
    /**
     * Determine if there's a related in the record.
     * @param id
     * @param record
     * @protected
     */
    hasRelated(id, record) {
        const dictionary = record[this.typeKey];
        if (!dictionary) {
            return false;
        }
        return (dictionary[`${id}`] && dictionary[`${id}`] !== null);
    }
    /**
     * Determine of there are entries of given type.
     * @param record
     * @protected
     */
    hasTypeEntries(record) {
        return !!record[this.typeKey];
    }
    /**
     * Throws when related not found.
     * @param id
     * @param record
     * @protected
     */
    throwWhenMissing(id, record) {
        if (!this.hasTypeEntries(record)) {
            // console.warn(`[RelatedService]: There are no entries for the [${this.typeKey}] [${id}] type in the record!`)
            throw new Error(`[RelatedService]: There are no entries for the [${this.typeKey}] type in the record!`);
        }
        if (!this.hasRelated(id, record)) {
            // console.warn(`[RelatedService]: There are no entries for the [${id}] ID & [${this.typeKey}] in the record!`)
            throw new Error(`[RelatedService]: There are no entries for the [${id}] ID & [${this.typeKey}] in the record!`);
        }
    }
}
